import { RouteConfig, RoutesGaurdConfig } from '../../shared/config/authorities-config';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { UserAuthorityService } from './user-authority.service';
import { StorageKeys } from '../../shared/models/storage-keys';
import { UtilityService } from './utility.service';
import { DeepLinkType } from '../../shared/utils/db-migration';

@Injectable()
export class AuthGuard implements CanActivateChild {
	routeAddress: string;
	routesGuardConfig: RouteConfig[];
	routePermission: RouteConfig;
	isAuthorized: boolean;
	readonly deeplinkStore = 'deep-link';
	readonly DeepLinkType = DeepLinkType;
	isPosModalShown = false;

	constructor(
		private router: Router,
		public localStorage: LocalStorageService,
		public userAuth: UserAuthorityService,
		public utilityService: UtilityService,
		private routesConfig: RoutesGaurdConfig,
	) {
		this.routesGuardConfig = this.routesConfig.getRoutesAndPermissionsArray();
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		try {
			const stateUrl = state.url.split('/');
			const finalUrl = stateUrl.slice(2).join('/');
			this.routeAddress = finalUrl;
			// this.handleDeepLink(route, finalUrl);
			this.getPermissionForRoute(this.routeAddress);
			if (!this.routePermission || !this.routePermission.permission) {
				if (JSON.parse(this.localStorage.get(StorageKeys.terms_and_conditions_status)) === false && !this.utilityService.runningModal) {
					this.utilityService.launchTCModal();
				}
				return true;
			}
			this.isAuthorized = this.userAuth.hasAuthority(this.routePermission.permission);
			if (this.isAuthorized) {
				return true;
			}
			return false;
		}
		catch (error) {
			console.log('Redirecting failed ---> ', error);
		}
	}


	handleDeepLink(route: ActivatedRouteSnapshot, url: string) {
		// const isDeepLink = route?.queryParams[`isDeepLink`] === 'true';
		// if(!isDeepLink){
		// 	return;
		// }
		// url = url?.replace('?isDeepLink=true','');
		// const payload = route?.queryParams[`notification`];
		// payload ? this.handleNotificationDeeplink(payload) : this.handleRegularDeeplink(url);
	}

	handleNotificationDeeplink(payload) {
		//     const deeplinkData = [
		//      { linkType: this.DeepLinkType.NOTIFICATION, payload},
		//     ];
		// this.indexDBService.add(deeplinkData, this.deeplinkStore)
		// .then(res => {
		// })
		// .catch(error => {
		// });
	}

	handleRegularDeeplink(url) {
		//     const deeplinkData = [
		//      { linkType: this.DeepLinkType.REGULAR, url}
		//     ];
		// this.indexDBService.add(deeplinkData, this.deeplinkStore)
		// .then(res => {
		// })
		// .catch(error => {
		// });
	}

	getPermissionForRoute(address) {
		this.routePermission = this.routesGuardConfig.find((route) => {
			if (route.path.includes(address)) {
				return route;
			}
		});
	}
}
